import { Box } from "@mui/material";
import React from "react";
import { colors } from "config/styles/themeColors";
import styles from "./Preloader.styled";

const Preloader = ({ color = colors.accents.loader }: { color?: string }) => {
  return (
    <Box sx={styles.wrapper(color)}>
      <Box sx={styles.firstCircle(color)} />
      <Box sx={styles.secondCircle(color)} />
      <Box sx={styles.dotsLoader(color)} />
    </Box>
  );
};

export default Preloader;
